import { isMobile } from 'root/utils/isMobile';
import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';
import { CookieMonster } from 'root/utils/cookies/cookieMonster';

function AlertBannerController(el) {
    this.el = el;
    this.cm = new CookieMonster();
}

AlertBannerController.prototype = {
    postInsertActions() {
        this.el.classList.add('js-alert-banner-show');
        this.el.classList.remove('js-alert-banner-null');
        this.titleElement = document.querySelector('[data-alert-banner=title]');
        gtm.alertBanner(this.titleElement).sendEvent('shown');
    },

    postClosedActions() {
        this.el.classList.remove('js-alert-banner-show');
        this.el.classList.add('js-alert-banner-hide');
        this.el.addEventListener('animationend', e => {
            e.currentTarget.classList.add('js-alert-banner-null');
        });

        gtm.alertBanner(this.titleElement).sendEvent('exit');
    },

    ctaClickHandler() {
        this.setAlertBannerCookie();
        gtm.alertBanner(this.titleElement).sendEvent('click');
    },

    closeHandler(e) {
        e.preventDefault();
        this.setAlertBannerCookie();
        // hide the banner after the close button is clicked
        this.postClosedActions();
    },

    /**
     * @param cookieName
     * @returns {boolean}
     */
    hasCookie(cookieName) {
        return cookieName && this.cm.getCookie(cookieName) === 1;
    },

    /**
     * On desktop: always return true
     * On mobile: return true if the Cookie Notification banner cookie has been set (ie: closed)
     * On mobile it is the case, so that we don't show 2 banners at a time, due to the small size of the mobile screen
     * @returns {boolean}
     */
    isCookieNotificationSetOnMobile() {
        if (isMobile.hasMobileDeviceSize()) {
            return this.hasCookie('_ls-cookie_notification');
        }
        return true;
    },

    /**
     * @returns {string}
     */
    getCookieName() {
        return `_ls-alert-banner-${this.el.dataset.alertBannerCookie}`;
    },

    setAlertBannerCookie() {
        window.registerCookieComplianceCallback({
            callback: () =>
                !('alertBannerShowEvenIfDismissed' in this.el.dataset) &&
                this.cm.setCookie(this.getCookieName(), 1, 90),
            category: 'functional',
            isCallOptanonWrapper: true,
        });
    },

    addEventListenerToElement() {
        const closeBtn = this.el.querySelector(`[data-alert-banner=close-btn]`);
        const ctaBtn = this.el.querySelector(`[data-alert-banner=cta-btn]`);
        closeBtn.addEventListener('click', this.closeHandler.bind(this));
        if (ctaBtn) {
            ctaBtn.addEventListener('click', this.ctaClickHandler.bind(this));
        }
    },

    init() {
        if (
            !this.cm.getCookie(this.getCookieName()) &&
            this.isCookieNotificationSetOnMobile() // on mobile we'll show the banner only if the cookie notificaiton has been closed.
        ) {
            this.addEventListenerToElement();
            this.postInsertActions();
        }
    },
};

const getBannerBasedOnRanking = els => {
    if (els.length > 0) {
        const sortedBanners = Array.from(els).sort((a, b) => {
            return (
                (b.dataset.alertBannerRank === 'on') -
                (a.dataset.alertBannerRank === 'on')
            );
        });
        return sortedBanners[0];
    }
    return null;
};

export default function AlertBanner(els) {
    if (getBannerBasedOnRanking(els)) {
        const alertBanner = new AlertBannerController(getBannerBasedOnRanking(els));
        alertBanner.init();
    }
}
